import { initializeTabs } from '../global/tabs.js';


document.addEventListener('DOMContentLoaded', () => {
    const salesforceFormTabs = document.querySelectorAll('.salesforce-tab-btn');
    const salesforceFormTabContents = document.querySelectorAll('.salesforce-tab-content');

    initializeTabs(salesforceFormTabs, salesforceFormTabContents);
});